import Input from '@cartwhl/ui/atoms/Input';
import Tooltip from '@cartwhl/ui/atoms/Tooltip';
import Text from '@cartwhl/ui/base/Text';
import CrossIcon from '@cartwhl/ui/icons/CrossIcon';
import GridIcon from '@cartwhl/ui/icons/GridIcon';
import ListIcon from '@cartwhl/ui/icons/ListIcon';
import SearchIcon from '@cartwhl/ui/icons/SearchIcon';
import Button from '@cartwhl/ui/input/Button';

import type { AssetLibraryTypeFilter } from '../AssetLibrary/assetLibraryFilters';
import SeeMoreInLibraryButton from './SeeMoreInLibraryButton';

type ViewMode = 'grid' | 'list';

export interface RecentBatchJobsSectionHeaderProps {
  title: string;
  searchInputName: string;
  libraryTypeFilter: Exclude<AssetLibraryTypeFilter, 'all'>;
  showControls: boolean;
  searchQuery: string;
  onSearchQueryChange: (value: string) => void;
  viewMode: ViewMode;
  onToggleViewMode: () => void;
}

export default function RecentBatchJobsSectionHeader({
  title,
  searchInputName,
  libraryTypeFilter,
  showControls,
  searchQuery,
  onSearchQueryChange,
  viewMode,
  onToggleViewMode,
}: RecentBatchJobsSectionHeaderProps) {
  return (
    <div className="mb-4 flex flex-wrap items-center justify-between gap-3">
      <Text as="h2" variant="studio/title/xl">
        {title}
      </Text>

      <div className="flex flex-wrap items-center gap-2">
        {showControls ? (
          <>
            <div className="relative w-56">
              <Input
                name={searchInputName}
                type="text"
                placeholder="Search jobs"
                className="pr-9"
                value={searchQuery}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                  onSearchQueryChange(event.target.value)
                }
              />
              {searchQuery ? (
                <button
                  type="button"
                  onClick={() => onSearchQueryChange('')}
                  className="absolute top-1/2 right-3 -translate-y-1/2 cursor-pointer"
                >
                  <CrossIcon className="h-4 w-4" />
                </button>
              ) : (
                <SearchIcon className="text-secondary absolute top-1/2 right-3 h-5 w-5 -translate-y-1/2" />
              )}
            </div>

            <Tooltip text={viewMode === 'grid' ? 'List view' : 'Grid view'}>
              <Button
                variant="secondary"
                size="sm"
                icon={
                  viewMode === 'grid' ? (
                    <ListIcon className="h-6 w-6" />
                  ) : (
                    <GridIcon className="h-6 w-6" />
                  )
                }
                className="border-gray-30 dark:bg-gray-90 dark:border-gray-70 h-8 w-8 border bg-white"
                onClick={onToggleViewMode}
              />
            </Tooltip>
          </>
        ) : null}
        <SeeMoreInLibraryButton typeFilter={libraryTypeFilter} />
      </div>
    </div>
  );
}
